import { html } from 'lit'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'
import HedeliusBaseItem from '../base-item.js'

customElements.define(
    'hedelius-right-item-model-range',
    class HedeliusRightItemModelRange extends HedeliusBaseItem {
        renderAnchor() {
            return html`
                <li class="border-b border-b-gray-200 py-8">
                    ${this.node.children.length > 0
                        ? html`
                              <button
                                  @click="${(e) => this._handleClick(e, this.node)}"
                                  class="group flex justify-between gap-1 text-left max-sm:flex-col"
                              >
                                  <div
                                      class="mb-3 flex flex-[5] flex-col gap-3 text-3xl font-black"
                                  >
                                      <span
                                          class="mr-auto border-b-2 border-b-white transition-colors group-hover:border-b-hdls-red"
                                          >${this.node.title}</span
                                      >
                                      <span class="plus-list text-base font-light"
                                          >${this.node.show_teaser
                                              ? unsafeHTML(this.node.teaser_text)
                                              : this.node.subtitle}
                                      </span>
                                  </div>
                                  ${this.node.teaser_image &&
                                  html`
                                      <div class="flex flex-[6] justify-center">
                                          <img
                                              class="object-contain"
                                              src="${this.node.teaser_image}-S400"
                                              alt="${this.node.image_alt}"
                                              title="${this.node.image_title}"
                                              loading="lazy"
                                          />
                                      </div>
                                  `}
                              </button>
                          `
                        : html`
                              <a
                                  @click="${(e) => this._handleClick(e, this.node)}"
                                  class="group flex justify-between gap-1 max-sm:flex-col"
                                  href="${this.node.href}"
                              >
                                  <div
                                      class="mb-3 flex flex-[5] flex-col gap-3 text-3xl font-black"
                                  >
                                      <span
                                          class="mr-auto border-b-2 border-b-white transition-colors group-hover:border-b-hdls-red"
                                          >${this.node.title}</span
                                      >
                                      <span class="plus-list text-base font-light"
                                          >${this.node.show_teaser
                                              ? unsafeHTML(this.node.teaser_text)
                                              : this.node.subtitle}
                                      </span>
                                  </div>
                                  ${this.node.teaser_image &&
                                  html`
                                      <div class="flex flex-[6] justify-center">
                                          <img
                                              class="object-contain"
                                              src="${this.node.teaser_image}-S400"
                                              alt="${this.node.image_alt}"
                                              title="${this.node.image_title}"
                                              loading="lazy"
                                          />
                                      </div>
                                  `}
                              </a>
                          `}
                </li>
            `
        }
    }
)
